import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Center } from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import { primaryColor } from "../../utils/colors";
import { MONTH_NAMES } from "../../utils/constants";

interface TableBulletinsProps {
  dataTable: any[];
  isLoaded: boolean;
}

const TableBulletins: FC<TableBulletinsProps> = ({ dataTable, isLoaded }) => {
  const handleDownload = (id: any) => {
    const downloadUrl = `/boletins/download/${id}`;

    window.open(downloadUrl, "_blank");
  };

  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Id", accessor: "id" },
      { Header: "Nome", accessor: "name" },
      {
        Header: "Mês/Ano",
        accessor: (row: any) => `${MONTH_NAMES[row.month - 1]}/${row.year}`,
      },
      { Header: "Tipo de boletim", accessor: "type.name" },
      { Header: "Província", accessor: "province.name", disableSortBy: true },
      {
        Header: "Município",
        accessor: (row: any) => row.county?.name ?? "-",
        disableSortBy: true,
      },
      {
        Header: "Ver Boletim",
        accessor: "ver",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <ViewIcon
              aria-label="ver"
              mr="8"
              color={primaryColor}
              boxSize={6}
              onClick={() => handleDownload(row.original.id)}
            />
          </Center>
        ),
      },
    ];
    return baseColumns;
  }, []);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "ver", hasShadow: true }]}
    />
  );
};

export default TableBulletins;
